import { z } from 'zod';
import { csvList } from './common.js';
import { visitFiltersSchema } from './visits.js';
/** Columns a report can show or export, in display order. Keys match `Visit`. */
export const REPORT_COLUMNS = [
    'id',
    'status',
    'scheduledAt',
    'durationMinutes',
    'technician',
    'facility',
    'facilityBu',
    'cluster',
    'scopeOfWork',
    'additionalTasks',
    'checkInAt',
    'checkOutAt',
    'checkInLocation',
    'checkOutLocation',
    'checkInIp',
    'checkOutIp',
    'engineerNotes',
    'adminNotes',
    'csat',
    'signedAt',
    'signedBy',
    'approvedAt',
    'cancelledAt',
    'cancellationReason',
    'createdAt',
];
/** Exported to CSV only by Super Admin (spec §6 privacy). */
export const SENSITIVE_COLUMNS = [
    'checkInIp',
    'checkOutIp',
    'checkInLocation',
    'checkOutLocation',
];
export const DEFAULT_REPORT_COLUMNS = [
    'id',
    'scheduledAt',
    'status',
    'technician',
    'facility',
    'cluster',
    'scopeOfWork',
    'checkInAt',
    'checkOutAt',
    'csat',
    'signedAt',
];
export const REPORT_COLUMN_LABELS = {
    id: 'Visit #',
    status: 'Status',
    scheduledAt: 'Scheduled (PT)',
    durationMinutes: 'Duration (min)',
    technician: 'Technician',
    facility: 'Facility',
    facilityBu: 'BU',
    cluster: 'Cluster',
    scopeOfWork: 'Scope of work',
    additionalTasks: 'Additional tasks',
    checkInAt: 'Check-in (PT)',
    checkOutAt: 'Check-out (PT)',
    checkInLocation: 'Check-in location',
    checkOutLocation: 'Check-out location',
    checkInIp: 'Check-in IP',
    checkOutIp: 'Check-out IP',
    engineerNotes: 'Engineer notes',
    adminNotes: 'Administrator notes',
    csat: 'CSAT',
    signedAt: 'Signed (PT)',
    signedBy: 'Signed by',
    approvedAt: 'Approved (PT)',
    cancelledAt: 'Cancelled (PT)',
    cancellationReason: 'Cancellation reason',
    createdAt: 'Created (PT)',
};
export const CSV_ROW_CAP = 50_000;
export const reportFiltersSchema = visitFiltersSchema.extend({
    columns: csvList(z.enum(REPORT_COLUMNS), REPORT_COLUMNS.length),
});
//# sourceMappingURL=reports.js.map